<template>
    <div class="card-body">
        <div class="text-center mb-3">
            <i class="icon-user-lock icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
            <h5 class="mb-0">{{ $t('auth.authentication.reset_password_title') }}</h5>
            <span class="d-block text-muted">{{ $t('auth.authentication.reset_password_description') }}</span>
        </div>

        <form @submit.prevent="reset">
            <FormGroup :label="$t('auth.authentication.confirmation_code')">
                <Input type="text" :placeholder="$t('auth.fields.code')" v-model="code"/>
            </FormGroup>

            <FormGroup :label="$t('auth.authentication.new_password')">
                <Input type="password" :placeholder="$t('auth.fields.password')" v-model="password"/>
            </FormGroup>

            <FormGroup :label="$t('auth.fields.password_confirmation')">
                <Input type="password" :placeholder="$t('auth.fields.password')" v-model="passwordConfirmation"/>
            </FormGroup>

            <div class="btn-group-justified">
                <Button size="sm" type="submit" color="primary">{{ $t('auth.buttons.send') }}<i class="icon-circle-right2 ml-2"></i></Button>
            </div>
        </form>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import { httpClient } from "../../../../../services/HttpClient";

export default {
    name: "ResetPasswordCard",
    components: {
        FormGroup,
        Input,
        Button,
    },
    props: ['email'],
    emits: ['password-reset'],
    data() {
        return {
            code: null,
            password: null,
            passwordConfirmation: null,
        }
    },
    methods: {
        async reset() {
            await httpClient.post('/authentication/reset', {
                email: this.email,
                code: this.code,
                password: this.password,
                password_confirmation: this.passwordConfirmation,
            });

            this.$emit('password-reset');
        },
    },
}
</script>
